import { FC } from "react"
import { Download } from "lucide-react"
import { Brand, ConnectorFormValues } from "../../../../../../../types"
import { FormikErrors } from "formik"
import BrandAutocomplete from "../../../../../brand-autocomplete"
import Autocomplete from "../../../../../form/autocomplete"
import ConnectorFormInput from "../../components/ConnectorFormInput"
import ConnectorFormButton from "../../components/ConnectorFormButton"
import ImportConnector from "../../import-connector"

interface BasicInfoSectionProps {
  values: ConnectorFormValues
  brands: Brand[]
  setFormField: (name: string, val: any) => void
  isCreate: boolean
  errors: FormikErrors<ConnectorFormValues>
  loOptions: Array<{ id: string; text: string }>
  selectedLo: { id: string; text: string } | undefined
  loQuery: string
  setLoQuery: (query: string) => void
  onImport: (data: Partial<ConnectorFormValues>) => void
  onExport: () => void
}

const BasicInfoSection: FC<BasicInfoSectionProps> = ({
  values,
  brands,
  setFormField,
  isCreate,
  errors,
  loOptions,
  selectedLo,
  loQuery,
  setLoQuery,
  onImport,
  onExport
}) => {
  return (
    <div className="border-b pb-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-medium">Basic Information</h3>
        {isCreate && <ImportConnector onImport={onImport} />}
        {!isCreate && (
          <ConnectorFormButton
            onClick={onExport}
            variant="secondary"
            className="flex items-center"
          >
            <Download size={14} className="mr-1" />
            Export JSON
          </ConnectorFormButton>
        )}
      </div>

      <div className="space-y-4">
        <ConnectorFormInput
          label="Connector Name"
          value={values.name}
          onChange={value => setFormField("name", value)}
          placeholder="e.g., Zapier Lead Webhook"
          error={errors.name}
          required
        />

        <div>
          {isCreate ? (
            <>
              <BrandAutocomplete
                brands={brands}
                selected={values.brand_id}
                direction="vertical"
                hideLabel
                onChange={value => setFormField("brand_id", value)}
              />
              {errors.brand_id && (
                <p className="text-red-500 text-sm mt-1">{errors.brand_id}</p>
              )}
            </>
          ) : (
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Brand *
              </label>
              <div className="w-full px-3 py-2 border border-gray-300 rounded-md bg-gray-50 text-gray-700">
                {brands.find(b => b.nid === values.brand_id)?.name ||
                  values.brand_id}
              </div>
            </div>
          )}
        </div>

        <div>
          {values.brand_id ? (
            <>
              <Autocomplete
                label="Owner (Loan Officer):"
                name="owner"
                placeholder="Search loan officer"
                value={selectedLo}
                query={loQuery}
                options={loOptions}
                direction="vertical"
                onChange={option => setFormField("owner", option.id)}
                onChangeQuery={setLoQuery}
              />
              {errors.owner && (
                <p className="text-red-500 text-sm mt-1">{errors.owner}</p>
              )}
            </>
          ) : (
            <>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Owner (Loan Officer) *
              </label>
              <div className="w-full px-3 py-2 border border-gray-300 rounded-md bg-gray-100 text-gray-500">
                Select a brand first
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  )
}

export default BasicInfoSection
